export default {
  namespaced: true,
  state: {
    info: {},
    token: 'admin'
  },

  mutations: {
    SET_TOKEN: (state, info) => {
      state.token = info
      state.info = info
      if (!info.token) {
        // location.reload()
      }
    }
  },
  actions: {
    login({ commit }, userInfo) {
      commit('SET_TOKEN', userInfo)
    },
    logout({ commit }) {
      commit('SET_TOKEN', {token: '', info: {}})
    }
  }
}
